// extracted by mini-css-extract-plugin
export default {"notification":"MessageBox_notification__-d-e9"};